export default __webpack_public_path__ + "media/Vijaya-Scholarship.c7fcc64c.png";